export default class CarSimYears{

    constructor()
    {
    let currentYear = new Date().getFullYear();
    this.years = [
        {
            value: '1',
            label:currentYear,
        },
        {
            value: '2',
            label:currentYear - 1,
        },
        {
            value: '3',
            label:currentYear - 2,
        },
        {
            value: '4',
            label:currentYear - 3,
        },
        {
            value: '5',
            label:currentYear - 4,
        }
        ];
    }

    years: SingleYear[];
} 

interface SingleYear{
    value: string;
    label: number;
}